'use client';

import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const MessageContext = /*#__PURE__*/React.createContext({
  messageId: '',
  message: null,
  role: undefined,
  status: undefined,
  streaming: false,
  error: false,
  isGrouped: false,
  variant: 'default',
  density: 'standard',
  showAvatar: false
});
if (process.env.NODE_ENV !== "production") MessageContext.displayName = "MessageContext";
export function MessageContextProvider(props) {
  const {
    children,
    value
  } = props;
  return /*#__PURE__*/_jsx(MessageContext.Provider, {
    value: value,
    children: children
  });
}
export function useMessageContext() {
  return React.useContext(MessageContext);
}